import authentication from './authentication';

const { checkIfAuthenticationIsRequired, logout } = authentication;

export default async function newCustomerForm() {
    const $form = document.getElementById('create-customer');

    if (!$form) {
        throw new Error('Could not location a form element');
    }

    $form.querySelector('#register', event => {
        event.preventDefault();

        function notAuthenticated() {
            location.href = event.target.href;
        }

        function authenticated() {
            logout(notAuthenticated);
        }

        checkIfAuthenticationIsRequired(authenticated, notAuthenticated);
    });

    $form.addEventListener('submit', event => {
        event.preventDefault();

        const { create, nextPageUrl } = Object.fromEntries(new FormData($form).entries());
        const params = new URLSearchParams();

        params.set('create', create);
        params.set('nextPageUrl', nextPageUrl);

        location.href = `${$form.dataset.action}?${params.toString()}`;
    });
}
